export const appLaunchUrlToPath = (
    appLaunchUrl: string
): string | undefined => {
    const url = new URL(appLaunchUrl);
    const isHttpScheme = url.protocol === "http:" || url.protocol === "https:";
    let path = url.pathname || "/";

    if (!isHttpScheme && url.host) {
        // For custom schemes the host often contains the first path segment, so include it.
        const hostPath = url.host.startsWith("/") ? url.host : `/${url.host}`;
        const normalizedPath =
            path === "/"
                ? ""
                : path.startsWith("/")
                ? path
                : `/${path}`;
        path = `${hostPath}${normalizedPath}`;
    }

    if (url.search) {
        return `${path}${url.search}`;
    }

    return path;
};
